import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ApiAppSettingsModel } from '../models/app-settings/api-app-settings.model';
import { Injectable } from '@angular/core';

export type ApiAppSettingsState = EntityState<ApiAppSettingsModel, string>;

function createInitialState(): ApiAppSettingsState {
  return {
    entities: {},
    ids: [],
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'api-app-settings', idKey: 'name' })
export class ApiAppSettingsStore extends EntityStore<ApiAppSettingsState> {
  constructor() {
    super(createInitialState());
  }
}
